import LocalActivityRoundedIcon from '@mui/icons-material/LocalActivityRounded'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { useIntl } from 'react-intl'
import { ParkingEventDTO } from '../../apis/parkingEvents/dto'

const WhitelistedVehicleIcon = () => {
  const intl = useIntl()
  return (
    <Tooltip title={intl.formatMessage({ id: 'common.text.exempt' })}>
      <LocalActivityRoundedIcon
        style={{
          verticalAlign: 'middle',
          marginRight: '0.5rem',
        }}
      />
    </Tooltip>
  )
}

export const WhitelistedVehicleIconWithLicensePlate = (props: {
  parkingEvent: ParkingEventDTO
}) => {
  return (
    <Box display="flex" width="100%" alignItems="center">
      <Typography width="5rem">{props.parkingEvent.licensePlate}</Typography>
      <Box width="2rem">
        {props.parkingEvent.parkingType === 'WHITELIST' ? (
          <WhitelistedVehicleIcon />
        ) : null}
      </Box>
    </Box>
  )
}

export default WhitelistedVehicleIcon
